import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Warning = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path d="M8.75 10.0001V11.5001H7.25V10.0001H8.75Z" fill="currentColor" />
    <path d="M8.75 9.00007V5.50007H7.25V9.00007H8.75Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.26533 10.9886L6.27461 2.44339C7.04728 1.12531 8.95273 1.12531 9.7254 2.4434L14.7347 10.9886C15.5163 12.3219 14.5548 14.0001 13.0093 14.0001H2.99073C1.44524 14.0001 0.483748 12.3219 1.26533 10.9886ZM7.56866 3.20197L2.55938 11.7472C2.36398 12.0805 2.60436 12.5001 2.99073 12.5001H13.0093C13.3957 12.5001 13.636 12.0805 13.4406 11.7472L8.43135 3.20197C8.23819 2.87245 7.76182 2.87245 7.56866 3.20197Z"
      fill="currentColor"
    />
  </Icon>
));

export default Warning;
